import { PreIPOEnquiresReducerStateType } from '@modules/pre-ipo-deals/pre-ipo-deals-section/types';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  offset: 0,
  limit: 25,
  search: '',
  order: 'desc',
  sortBy: 'dateOfEnquiry',
  clearPage: true,
  totalCount: 0,
  date: null,
  status: 'all',
  deals: '',
  updateSharePriceClicked: false,
  markAsCompletedClicked: false,
  droppedOffClicked: false,
  selectedUsers: [],
  closedClicked: false
} as PreIPOEnquiresReducerStateType;

export const preIPOCrmListStateReducerSlice = createSlice({
  name: 'preIPOCrmListStateReducer',
  initialState,
  reducers: {
    resetPreIPOCrmListStateReducerValues: state => ({
      ...state,
      offset: 0,
      limit: 25,
      search: '',
      order: 'desc',
      sortBy: 'dateOfEnquiry',
      totalCount: 0,
      date: null,
      status: 'all',
      deals: '',
      selectedUsers: [],
      updateSharePriceClicked: false,
      markAsCompletedClicked: false,
      droppedOffClicked: false,
      closedClicked: false
    }),
    updatePreIPOCrmListStateReducerValues: (state, { payload }) => ({
      ...state,
      ...payload
    }),
    resetPreIPOCrmFiltersStateReducerValues: state => ({
      ...state,
      search: '',
      date: null,
      status: 'all',
      deals: '',
      selectedUsers: []
    })
  }
});

export const {
  resetPreIPOCrmListStateReducerValues,
  updatePreIPOCrmListStateReducerValues,
  resetPreIPOCrmFiltersStateReducerValues
} = preIPOCrmListStateReducerSlice.actions;

export default preIPOCrmListStateReducerSlice.reducer;
